export default class Category {
    id = undefined;
    title = "";
    createdAt = 0;
    updatedAt = 0;
}